"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconNamesLogo = exports.IconNames8 = exports.IconNames60 = exports.IconNames40 = exports.IconNames24 = exports.IconNames20 = exports.IconNames16 = void 0;
var IconNames8 = /*#__PURE__*/function (IconNames8) {
  IconNames8["ADD"] = "plus";
  IconNames8["ARROW_RIGHT"] = "arrow-right";
  IconNames8["BULLET_LARGE"] = "bullet-large";
  IconNames8["BULLET_SMALL"] = "bullet-small";
  IconNames8["CARET_DOWN"] = "caret-down";
  IconNames8["CARET_LEFT"] = "caret-left";
  IconNames8["CARET_RIGHT"] = "caret-right";
  IconNames8["CARET_UP"] = "caret-up";
  IconNames8["CHECK"] = "check";
  IconNames8["CROSS"] = "cross";
  IconNames8["DASH"] = "dash";
  IconNames8["DOUBLE_CARET_LEFT"] = "double-caret-left";
  IconNames8["DOUBLE_CARET_RIGHT"] = "double-caret-right";
  IconNames8["EXCLAMATION"] = "exclamation";
  IconNames8["INFORMATION"] = "information";
  IconNames8["LINE"] = "dash";
  IconNames8["PLUS"] = "plus";
  IconNames8["TICK"] = "check";
  return IconNames8;
}({});
exports.IconNames8 = IconNames8;
var IconNames16 = /*#__PURE__*/function (IconNames16) {
  IconNames16["ADD"] = "plus";
  IconNames16["ADVERT"] = "advert";
  IconNames16["APPLIED"] = "arrow-up-right-into-document";
  IconNames16["ARCHIVE"] = "archive";
  IconNames16["ARROW_DOWN"] = "arrow-down";
  IconNames16["ARROW_DOWN_A_Z"] = "arrow-down-a-z";
  IconNames16["ARROW_DOWN_LEFT"] = "arrow-down-left";
  IconNames16["ARROW_DOWN_RIGHT"] = "arrow-down-right";
  IconNames16["ARROW_DOWN_Z_A"] = "arrow-down-z-a";
  IconNames16["ARROW_LEFT"] = "arrow-left";
  IconNames16["ARROW_LEFT_ARC"] = "arrow-left-arc";
  IconNames16["ARROW_RIGHT"] = "arrow-right";
  IconNames16["ARROW_RIGHT_ARC"] = "arrow-right-arc";
  IconNames16["ARROW_RIGHT_FROM_BRACKET"] = "arrow-right-from-bracket";
  IconNames16["ARROW_RIGHT_INTO_BRACKET"] = "arrow-right-into-bracket";
  IconNames16["ARROW_ROTATE_LEFT"] = "arrow-rotate-left";
  IconNames16["ARROW_ROTATE_RIGHT"] = "arrow-rotate-right";
  IconNames16["ARROW_ROTATE_RIGHT_HALF"] = "arrow-rotate-right-half";
  IconNames16["ARROW_UP"] = "arrow-up";
  IconNames16["ARROW_UP_LEFT"] = "arrow-up-left";
  IconNames16["ARROW_UP_RIGHT"] = "arrow-up-right";
  IconNames16["ARROW_UP_RIGHT_FROM_SQUARE"] = "arrow-up-right-from-square";
  IconNames16["ARROW_UP_RIGHT_INTO_DOCUMENT"] = "arrow-up-right-into-document";
  IconNames16["ARROWS_UP_DOWN"] = "arrows-up-down";
  IconNames16["ATTACHMENT"] = "paperclip";
  IconNames16["BAN"] = "ban";
  IconNames16["BASKET"] = "basket";
  IconNames16["BELL"] = "bell";
  IconNames16["BIN"] = "bin";
  IconNames16["BOLD"] = "bold";
  IconNames16["BOOKS"] = "books";
  IconNames16["BOX"] = "box";
  IconNames16["BRAND_ADONISHR"] = "brand-adonishr";
  IconNames16["BRAND_ADP"] = "brand-adp";
  IconNames16["BRAND_AIRCALL"] = "brand-aircall";
  IconNames16["BRAND_AZURE"] = "brand-azure";
  IconNames16["BRAND_BAMBOO"] = "brand-bamboo";
  IconNames16["BRAND_BIZIMPLY"] = "brand-bizimply";
  IconNames16["BRAND_BOB"] = "brand-bob";
  IconNames16["BRAND_BREATHE"] = "brand-breathe";
  IconNames16["BRAND_BRYQ"] = "brand-bryq";
  IconNames16["BRAND_CANDITECH"] = "brand-canditech";
  IconNames16["BRAND_CAPPFINITY"] = "brand-cappfinity";
  IconNames16["BRAND_CAREPLANNER"] = "brand-careplanner";
  IconNames16["BRAND_CASCADE"] = "brand-cascade";
  IconNames16["BRAND_CERTN"] = "brand-certn";
  IconNames16["BRAND_CEZANNE"] = "brand-cezanne";
  IconNames16["BRAND_CHECKR"] = "brand-checkr";
  IconNames16["BRAND_CINTRA"] = "brand-cintra";
  IconNames16["BRAND_CODILITY"] = "brand-codility";
  IconNames16["BRAND_CRITERIA"] = "brand-criteria";
  IconNames16["BRAND_CRONOFY"] = "brand-cronofy";
  IconNames16["BRAND_CSI"] = "brand-csi";
  IconNames16["BRAND_DEEL"] = "brand-deel";
  IconNames16["BRAND_DOCUSIGN"] = "brand-docusign";
  IconNames16["BRAND_DROPBOXSIGN"] = "brand-dropboxsign";
  IconNames16["BRAND_FACEBOOK"] = "brand-facebook";
  IconNames16["BRAND_FIRSTADVANTAGE"] = "brand-firstadvantage";
  IconNames16["BRAND_GLASSDOOR"] = "brand-glassdoor";
  IconNames16["BRAND_GOOGLE"] = "brand-google";
  IconNames16["BRAND_GOOGLE_ADS"] = "brand-googleads";
  IconNames16["BRAND_GOTO"] = "brand-goto";
  IconNames16["BRAND_GUSTO"] = "brand-gusto";
  IconNames16["BRAND_HELLOSIGN"] = "brand-hellosign";
  IconNames16["BRAND_HIREFLIX"] = "brand-hireflix";
  IconNames16["BRAND_HIRERIGHT"] = "brand-hireright";
  IconNames16["BRAND_HUMAANS"] = "brand-humaans";
  IconNames16["BRAND_INDEED"] = "brand-indeed";
  IconNames16["BRAND_INSTAGRAM"] = "brand-instagram";
  IconNames16["BRAND_INTELLIHR"] = "brand-intellihr";
  IconNames16["BRAND_INTERCOM"] = "brand-intercom";
  IconNames16["BRAND_IRISH_JOB_BOARD"] = "brand-irish-job-board";
  IconNames16["BRAND_ITRENT"] = "brand-itrent";
  IconNames16["BRAND_JOTFORM"] = "brand-jotform";
  IconNames16["BRAND_LINKEDIN"] = "brand-linkedin";
  IconNames16["BRAND_MEVITAE"] = "brand-mevitae";
  IconNames16["BRAND_MYINTERVIEW"] = "brand-myinterview";
  IconNames16["BRAND_ORACLE"] = "brand-oracle";
  IconNames16["BRAND_OUTMATCH"] = "brand-outmatch";
  IconNames16["BRAND_PEOPLEHR"] = "brand-peoplehr";
  IconNames16["BRAND_PINPOINT"] = "brand-pinpoint";
  IconNames16["BRAND_PREDICTIVE_INDEX"] = "brand-predictive-index";
  IconNames16["BRAND_REFNOW"] = "brand-refnow";
  IconNames16["BRAND_SAGE"] = "brand-sage";
  IconNames16["BRAND_SAML"] = "brand-saml";
  IconNames16["BRAND_SAPLING"] = "brand-sapling";
  IconNames16["BRAND_SEEK"] = "brand-seek";
  IconNames16["BRAND_SLACK"] = "brand-slack";
  IconNames16["BRAND_SONRU"] = "brand-sonru";
  IconNames16["BRAND_STERLING"] = "brand-sterling";
  IconNames16["BRAND_TALENT"] = "brand-talent";
  IconNames16["BRAND_TESTGORILLA"] = "brand-testgorilla";
  IconNames16["BRAND_TEAMS"] = "brand-teams";
  IconNames16["BRAND_TOTALJOBS"] = "brand-totaljobs";
  IconNames16["BRAND_TRUSTID"] = "brand-trustid";
  IconNames16["BRAND_TWILIO"] = "brand-twilio";
  IconNames16["BRAND_TWITTER"] = "brand-twitter";
  IconNames16["BRAND_UNSPLASH"] = "brand-unsplash";
  IconNames16["BRAND_WINDOWS"] = "brand-windows";
  IconNames16["BRAND_ZAPIER"] = "brand-zapier";
  IconNames16["BRAND_ZINC"] = "brand-zinc";
  IconNames16["BRAND_ZIPRECRUITER"] = "brand-ziprecruiter";
  IconNames16["BRAND_ZOOM"] = "brand-zoom";
  IconNames16["BRIEFCASE"] = "briefcase";
  IconNames16["BUILDINGS"] = "buildings";
  IconNames16["BULLET"] = "bullet";
  IconNames16["CALENDAR"] = "calendar";
  IconNames16["CANDIDATES"] = "users";
  IconNames16["CARDS"] = "grid";
  IconNames16["CAROUSEL"] = "carousel";
  IconNames16["CHART_PIE"] = "chart-pie";
  IconNames16["CHAT"] = "comment-round";
  IconNames16["CHECK"] = "check";
  IconNames16["CHECK_CIRCLE"] = "check-circle";
  IconNames16["CHECK_DOUBLE"] = "check-double";
  IconNames16["CHECK_SQUARE"] = "check-square";
  IconNames16["CHECK_SQUARE_FILLED"] = "check-square-filled";
  IconNames16["CHECK_SQUARE_PLUS"] = "check-square-plus";
  IconNames16["CHECKED"] = "check-square-filled";
  IconNames16["CHEVRON_DOWN"] = "chevron-down";
  IconNames16["CHEVRON_LEFT"] = "chevron-left";
  IconNames16["CHEVRON_LEFT_RIGHT"] = "chevron-left-right";
  IconNames16["CHEVRON_RIGHT"] = "chevron-right";
  IconNames16["CHEVRON_UP"] = "chevron-up";
  IconNames16["CHEVRONS_DOWN"] = "chevrons-down";
  IconNames16["CHEVRONS_RIGHT"] = "chevrons-right";
  IconNames16["CIRCLE"] = "circle";
  IconNames16["CIRCLE_DASHED"] = "circle-dashed";
  IconNames16["CIRCLES"] = "circles";
  IconNames16["CLIPBOARD"] = "clipboard";
  IconNames16["CLIPBOARD_CHECK"] = "clipboard-check";
  IconNames16["CLIPBOARD_USER"] = "clipboard-user";
  IconNames16["CLOCK"] = "clock";
  IconNames16["CLOUD_UPLOAD"] = "cloud-upload";
  IconNames16["CLOSE"] = "cross-circle";
  IconNames16["CODE"] = "code";
  IconNames16["COG"] = "cog";
  IconNames16["COLUMNS_2"] = "columns-2";
  IconNames16["COLUMNS_3"] = "columns-3";
  IconNames16["COLUMNS_FILLED_HALF"] = "columns-filled-half";
  IconNames16["COMMENT_RECTANGLE_LINE"] = "comment-rectangle-line";
  IconNames16["COMMENT_ROUND"] = "comment-round";
  IconNames16["COMMENT_SQUARE"] = "comment-square";
  IconNames16["COMMENT_SQUARE_SLASH"] = "comment-square-slash";
  IconNames16["COMMENTS"] = "comment-rectangle-line";
  IconNames16["COPY"] = "copy";
  IconNames16["COMPANY"] = "buildings";
  IconNames16["COMPARE"] = "compare";
  IconNames16["CREATE_TASK"] = "create-task";
  IconNames16["CROSS"] = "cross";
  IconNames16["CROSSHAIR"] = "crosshair";
  IconNames16["CROSS_CIRCLE"] = "cross-circle";
  IconNames16["CUBE"] = "box";
  IconNames16["CURSOR"] = "cursor";
  IconNames16["DASH"] = "dash";
  IconNames16["DELETE"] = "bin";
  IconNames16["DEPARTMENT"] = "box";
  IconNames16["DEVICE_MONITOR"] = "device-monitor";
  IconNames16["DEVICE_TABLET"] = "device-tablet";
  IconNames16["DOCUMENT"] = "document";
  IconNames16["DOWNLOAD"] = "download";
  IconNames16["DRAFT"] = "pencil-line";
  IconNames16["DROPLET"] = "droplet";
  IconNames16["DUPLICATE"] = "duplicate";
  IconNames16["EDIT"] = "pencil-square";
  IconNames16["ELLIPSIS_HORIZONTAL"] = "ellipsis-horizontal";
  IconNames16["EMAIL"] = "envelope-closed";
  IconNames16["EMAIL_OPEN"] = "envelope-open";
  IconNames16["ENVELOPE_CLOSED"] = "envelope-closed";
  IconNames16["ENVELOPE_OPEN"] = "envelope-open";
  IconNames16["ERROR"] = "error";
  IconNames16["EXCLAMATION_CIRCLE"] = "exclamation-circle";
  IconNames16["EXCLAMATION_TRIANGLE"] = "exclamation-triangle";
  IconNames16["EYE"] = "eye";
  IconNames16["EYE_OFF"] = "eye-slash";
  IconNames16["EYE_SLASH"] = "eye-slash";
  IconNames16["FACE_ANGUISH"] = "face-anguish";
  IconNames16["FACE_FROWN"] = "face-frown";
  IconNames16["FACE_GRIN"] = "face-grin";
  IconNames16["FACE_NEUTRAL"] = "face-neutral";
  IconNames16["FACE_SMILE"] = "face-smile";
  IconNames16["FILTER"] = "funnel";
  IconNames16["FLOPPY_DISK"] = "floppy-disk";
  IconNames16["FOLDER"] = "folder";
  IconNames16["FUNNEL"] = "funnel";
  IconNames16["GEAR"] = "cog";
  IconNames16["GLOBE"] = "globe";
  IconNames16["GRID"] = "grid";
  IconNames16["GRIP"] = "grip";
  IconNames16["H1"] = "h1";
  IconNames16["H2"] = "h2";
  IconNames16["H3"] = "h3";
  IconNames16["HEAD"] = "head";
  IconNames16["HEADSET"] = "headset";
  IconNames16["HEADING1"] = "h1";
  IconNames16["HEADING2"] = "h2";
  IconNames16["HEADING3"] = "h3";
  IconNames16["HEART"] = "heart";
  IconNames16["HELP"] = "question-circle";
  IconNames16["HERO"] = "hero";
  IconNames16["HIDE"] = "eye-slash";
  IconNames16["HIERARCHY"] = "hierarchy";
  IconNames16["HIRED"] = "check-circle";
  IconNames16["HOURGLASS"] = "hourglass";
  IconNames16["HOUSE"] = "house";
  IconNames16["ID_CARD"] = "id-card";
  IconNames16["IMAGE"] = "image";
  IconNames16["INDENT_LEFT"] = "indent-left";
  IconNames16["INDENT_RIGHT"] = "indent-right";
  IconNames16["INFO"] = "info-circle";
  IconNames16["INFO_CIRCLE"] = "info-circle";
  IconNames16["INTERVIEW"] = "comment-square";
  IconNames16["ITALIC"] = "italic";
  IconNames16["JOB"] = "briefcase";
  IconNames16["KANBAN"] = "kanban";
  IconNames16["LIGHTBULB"] = "lightbulb";
  IconNames16["LIGHTNING"] = "lightning";
  IconNames16["LINE"] = "dash";
  IconNames16["LINE_STACK"] = "line-stack";
  IconNames16["LINE_STACK_FILTER"] = "line-stack-filter";
  IconNames16["LINK"] = "link";
  IconNames16["LIST_BULLETED"] = "list-bulleted";
  IconNames16["LIST_NUMBERED"] = "list-numbered";
  IconNames16["LOADING"] = "loading";
  IconNames16["LOCATION"] = "globe";
  IconNames16["LOCK"] = "lock";
  IconNames16["LOCK_OPEN"] = "lock-open";
  IconNames16["LOGOUT"] = "arrow-right-from-bracket";
  IconNames16["MAGNIFYING_GLASS"] = "magnifying-glass";
  IconNames16["MAGNIFYING_GLASS_DOCUMENT"] = "magnifying-glass-document";
  IconNames16["MAGNIFYING_GLASS_USER"] = "magnifying-glass-user";
  IconNames16["MAP_PIN"] = "map-pin";
  IconNames16["MEGAPHONE"] = "megaphone";
  IconNames16["MENU"] = "line-stack";
  IconNames16["MIC"] = "mic";
  IconNames16["MINUS"] = "dash";
  IconNames16["MOBILE_PHONE"] = "mobile-phone";
  IconNames16["NUMBER_CIRCLE"] = "number-circle";
  IconNames16["NOTIFICATIONS"] = "bell";
  IconNames16["OFFICE"] = "buildings";
  IconNames16["OVERFLOW"] = "ellipsis-horizontal";
  IconNames16["PAPERCLIP"] = "paperclip";
  IconNames16["PATH"] = "path";
  IconNames16["PAUSE"] = "pause";
  IconNames16["PAUSE_CIRCLE"] = "pause-circle";
  IconNames16["PENCIL_LINE"] = "pencil-line";
  IconNames16["PENCIL_SQUARE"] = "pencil-square";
  IconNames16["PHONE"] = "mobile-phone";
  IconNames16["PINPOINT_AI"] = "pinpoint-ai";
  IconNames16["PINPOINT_AI_COLOR"] = "pinpoint-ai-color";
  IconNames16["PLANE"] = "plane";
  IconNames16["PLAY"] = "play";
  IconNames16["PLUS"] = "plus";
  IconNames16["PLUS_CIRCLE"] = "plus-circle";
  IconNames16["PRINT"] = "print";
  IconNames16["QUESTION_CIRCLE"] = "question-circle";
  IconNames16["QUOTE"] = "quote";
  IconNames16["RATING_1"] = "face-anguish";
  IconNames16["RATING_2"] = "face-frown";
  IconNames16["RATING_3"] = "face-neutral";
  IconNames16["RATING_4"] = "face-smile";
  IconNames16["RATING_5"] = "face-grin";
  IconNames16["REARRANGE"] = "grip";
  IconNames16["RECTANGLE_STACK"] = "rectangle-stack";
  IconNames16["RECTANGLE_VERTICAL_STACK"] = "rectangle-vertical-stack";
  IconNames16["REDO"] = "arrow-right-arc";
  IconNames16["REJECTED"] = "ban";
  IconNames16["REVIEW"] = "magnifying-glass-document";
  IconNames16["ROTATE_CCW"] = "arrow-rotate-left";
  IconNames16["ROTATE_CW"] = "arrow-rotate-right";
  IconNames16["SAVE"] = "floppy-disk";
  IconNames16["SCORECARD"] = "check-square";
  IconNames16["SEARCH"] = "magnifying-glass";
  IconNames16["SEAT"] = "seat";
  IconNames16["SECRET"] = "secret";
  IconNames16["SHARE_NODES"] = "share-nodes";
  IconNames16["SENDING"] = "chevrons-right";
  IconNames16["SETTINGS"] = "cog";
  IconNames16["SHUFFLE"] = "shuffle";
  IconNames16["SLIDERS"] = "sliders";
  IconNames16["SPLIT"] = "split";
  IconNames16["SORT_ASC"] = "arrow-down-a-z";
  IconNames16["SORT_DESC"] = "arrow-down-z-a";
  IconNames16["SPLIT_VIEW"] = "columns-2";
  IconNames16["SQUARE"] = "square";
  IconNames16["STACK"] = "stack";
  IconNames16["STACKED_VIEW"] = "rectangle-stack";
  IconNames16["STAR"] = "star";
  IconNames16["STAR_FILLED"] = "star-filled";
  IconNames16["STOPWATCH"] = "stopwatch";
  IconNames16["SUCCESS"] = "success";
  IconNames16["TABLE"] = "table";
  IconNames16["TAG"] = "tag";
  IconNames16["TAG_SLASH"] = "tag-slash";
  IconNames16["TEXT"] = "text";
  IconNames16["TICK"] = "check";
  IconNames16["UNCHECKED"] = "square";
  IconNames16["UNDERLINE"] = "underline";
  IconNames16["UNGROUP"] = "ungroup";
  IconNames16["UNDO"] = "arrow-left-arc";
  IconNames16["UPDATES"] = "megaphone";
  IconNames16["UPLOAD"] = "upload";
  IconNames16["USER"] = "user";
  IconNames16["USER_CIRCLE"] = "user-circle";
  IconNames16["USER_CROSS"] = "user-cross";
  IconNames16["USER_PLUS"] = "user-plus";
  IconNames16["USERS"] = "users";
  IconNames16["VIDEO"] = "video";
  IconNames16["WARNING"] = "exclamation-triangle";
  IconNames16["WEIGHT"] = "weight";
  IconNames16["WORKFLOW"] = "path";
  return IconNames16;
}({});
exports.IconNames16 = IconNames16;
var IconNames20 = /*#__PURE__*/function (IconNames20) {
  IconNames20["CLIPBOARD_USER"] = "clipboard-user";
  IconNames20["HEAD"] = "head";
  IconNames20["HIERARCHY"] = "hierarchy";
  IconNames20["ONBOARDING"] = "onboarding";
  IconNames20["RECRUITMENT"] = "recruitment";
  return IconNames20;
}({});
exports.IconNames20 = IconNames20;
var IconNames24 = /*#__PURE__*/function (IconNames24) {
  IconNames24["ADVERTS"] = "adverts";
  IconNames24["CANDIDATES"] = "candidates";
  IconNames24["COMPANY"] = "company";
  IconNames24["DASHBOARD"] = "dashboard";
  IconNames24["INSIGHTS"] = "insights";
  IconNames24["JOBS"] = "jobs";
  IconNames24["ONBOARDING"] = "onboarding";
  IconNames24["RECRUITMENT"] = "recruitment";
  IconNames24["SETTINGS"] = "settings";
  IconNames24["SURVEYS_REVERSED"] = "surveys-reversed";
  IconNames24["USER"] = "user";
  return IconNames24;
}({});
exports.IconNames24 = IconNames24;
var IconNames40 = /*#__PURE__*/function (IconNames40) {
  IconNames40["FILE"] = "file";
  IconNames40["JPG"] = "jpg";
  IconNames40["PNG"] = "png";
  IconNames40["SVG"] = "svg";
  return IconNames40;
}({});
exports.IconNames40 = IconNames40;
var IconNames60 = /*#__PURE__*/function (IconNames60) {
  IconNames60["CIRCLE"] = "circle";
  IconNames60["CRESCENTS"] = "crescents";
  IconNames60["CROSS"] = "cross";
  IconNames60["DIAMOND"] = "diamond";
  IconNames60["FLOWER"] = "flower";
  IconNames60["RAINBOW"] = "rainbow";
  IconNames60["TARGET"] = "target";
  IconNames60["WINDOW"] = "window";
  return IconNames60;
}({});
exports.IconNames60 = IconNames60;
var IconNamesLogo = /*#__PURE__*/function (IconNamesLogo) {
  IconNamesLogo["SOCIAL_FACEBOOK"] = "social-facebook";
  IconNamesLogo["SOCIAL_GOOGLE"] = "social-google";
  IconNamesLogo["SOCIAL_LINKEDIN"] = "social-linkedin";
  IconNamesLogo["SOCIAL_MICROSOFT"] = "social-microsoft";
  IconNamesLogo["SOCIAL_TWITTER"] = "social-twitter";
  IconNamesLogo["SOCIAL_WHATSAPP"] = "social-whatsapp";
  return IconNamesLogo;
}({});
exports.IconNamesLogo = IconNamesLogo;